export default "\r\n<!-- HEADER -->\r\n\r\n<p>pages works!</p>\r\n<router-outlet></router-outlet>\r\n"